import PropTypes from 'prop-types';
import React from 'react';
import { Dropdown as uiDropdown, Flex } from 'ui';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';

const Dropdown = styled(uiDropdown)`
  width: 100%;
`;

const ToolbarDropdown = (props) => {
  const { label, ...rest } = props;

  return (
    <Flex fdc>
      {label &&
        <label>
          {label}
        </label>}
      <Dropdown {...rest} />
    </Flex>
  );
};

ToolbarDropdown.propTypes = {
  values: PropTypes.array.isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  valueKey: PropTypes.string,
  valueLabel: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default injectIntl(ToolbarDropdown);
